export default {
    bar: { 
        display: 'flex',
        flexDirection: 'row',
        height: '120px',
        backgroundColor: '#ededed'
    }, 

    container: { 
        display: 'flex',
        flexDirection: 'row',
        width: '80%',
        height: '100%',
        margin: '0 auto',
        backgroundColor: '#ededed'
    },

    brand: { 
        maxHeight: '100%',
        padding: '10px'
    },

    item: { 
        display: 'block',
        padding: '24px', 
        fontSize: '20px',
        fontWeight: 'bold'
    }, 

    img: { 
        maxHeight: '100%',
    },

    ul: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        listStyleType: 'none'
    },
}